
import { useState, useEffect } from "react";

import { useSearchParams } from "react-router-dom";


import { getJobCostingData, JobCostingItem } from "../../data/jobData";

import "../Styles.css";
import JobCostingsGrid from "../../components/grids/JobCostingsGrid";

const JobCosting = (props: any) => {


  const [jobCostingData, setJobCostingData] = useState<JobCostingItem[]>([])

  const [searchParams] = useSearchParams();
  const id = searchParams.getAll("id")[0];
  const jobId = searchParams.getAll("jid")[0];


  const getJobCostings = () => {
    if (id) {
      getJobCostingData(Number(id))
        .then(res => setJobCostingData(res))
        .catch(err => console.log(err))
    }
  }

  useEffect(() => {
    getJobCostings()
  }, [id])

  return (
    <JobCostingsGrid 
    jobId={id}
    jobRef={jobId}
    onData={jobCostingData} 
    onRefresh={getJobCostings} />
  )


};

export default JobCosting;
